"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var clr2prop = function clr2prop(clr, minValue, maxValue) {
  return Math.min(1, Math.max(0, (clr - minValue) / maxValue));
};

var color = exports.color = function color(indata, shrinkMax, shrinkMin, _ref) {
  var depth = _ref.depth,
      width = _ref.width,
      height = _ref.height;

  var maxValue = Math.pow(2, depth) - 1;
  var minValue = 0;

  if (shrinkMin) {
    minValue = maxValue;
    for (var i = 0; i < indata.length; i += 1) {
      // Alpha channel
      if ((i + 1) % 4 !== 0) {
        var clr = indata[i];
        if (minValue > clr) {
          minValue = clr;
          if (minValue === 0) {
            break;
          }
        }
      }
    }
  }

  if (shrinkMax) {
    var newMaxValue = -1;
    for (var _i = 0; _i < indata.length; _i += 1) {
      // Alpha channel
      if ((_i + 1) % 4 !== 0) {
        var _clr = indata[_i];
        if (newMaxValue < _clr) {
          newMaxValue = _clr;
          if (newMaxValue === maxValue) {
            break;
          }
        }
      }
    }
    maxValue = newMaxValue;
  }

  var outData = new Float32Array(width * height * 3);
  for (var _i2 = 0; _i2 < indata.length / 4; _i2 += 1) {
    var inPos = _i2 << 2; // Same as * 4
    var outPos = _i2 * 3;

    outData[outPos] = clr2prop(indata[inPos], minValue, maxValue);
    outData[outPos + 1] = clr2prop(indata[inPos + 1], minValue, maxValue);
    outData[outPos + 2] = clr2prop(indata[inPos + 2], minValue, maxValue);
  }
  return outData;
};

var grayscale = exports.grayscale = function grayscale(indata, shrinkMax, shrinkMin, _ref2) {
  var depth = _ref2.depth;

  var maxValue = Math.pow(2, depth) - 1;
  var minValue = 0;

  if (shrinkMin) {
    minValue = maxValue;
    for (var i = 0; i < indata.length; i += 1) {
      var clr = indata[i];
      if (minValue > clr) {
        minValue = clr;
        if (minValue === 0) {
          break;
        }
      }
    }
  }

  if (shrinkMax) {
    var newMaxValue = -1;
    for (var _i3 = 0; _i3 < indata.length; _i3 += 1) {
      var _clr2 = indata[_i3];
      if (newMaxValue < _clr2) {
        newMaxValue = _clr2;
        if (newMaxValue === maxValue) {
          break;
        }
      }
    }
    maxValue = newMaxValue;
  }

  var outData = new Float32Array(indata.length);
  for (var _i4 = 0; _i4 < indata.length; _i4 += 1) {
    outData[_i4] = clr2prop(indata[_i4], minValue, maxValue);
  }
  return outData;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/propData.js
// module id = 1098
// module chunks = 0